import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f557d6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wallet rel" }
const _hoisted_2 = { style: {"line-height":"20px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-angle-right icon-size",
  style: {"margin-left":"6px","font-size":"18px"}
}, null, -1))
const _hoisted_4 = { class: "wallet-balance-num" }
const _hoisted_5 = { class: "price-unit" }
const _hoisted_6 = {
  class: "wallet-balance-btn recharge",
  style: {"height":"30px"}
}
const _hoisted_7 = {
  key: 2,
  style: {"padding-bottom":"20px","white-space":"nowrap"}
}
const _hoisted_8 = { style: {"line-height":"20px"} }
const _hoisted_9 = { style: {"font-weight":"700","font-size":"14px","margin-left":"4px"} }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = {
  key: 0,
  class: "deliver-num"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/报警灯.png",
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_13 = { class: "tips" }
const _hoisted_14 = {
  key: 1,
  class: "deliver-num"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wallet-line" }, null, -1))
const _hoisted_16 = { class: "wallet-bottom" }
const _hoisted_17 = { style: {"display":"flex","width":"100%"} }
const _hoisted_18 = { class: "wallet-bottom-cartAndMsg" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/Client/coupon/Coupon_icon.png" }, null, -1))
const _hoisted_20 = { class: "wallet-bottom-title" }
const _hoisted_21 = {
  class: "wallet-bottom-red",
  style: {"color":"#EA3B43"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wallet-bottom-line" }, null, -1))
const _hoisted_23 = { class: "wallet-bottom-cartAndMsg" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/Client/coupon/Shopping_icon.png" }, null, -1))
const _hoisted_25 = { class: "wallet-bottom-title" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wallet-bottom-line" }, null, -1))
const _hoisted_27 = { class: "wallet-bottom-cartAndMsg" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/Client/coupon/Remind_icon.png" }, null, -1))
const _hoisted_29 = { class: "wallet-bottom-title" }
const _hoisted_30 = { style: {"color":"#1C2026"} }

import Transfer from '@/views/fund/FundList/transfer.vue'
import AppLink from '@/components/common/AppLink.vue'
import { useRtfix, isD2C, isJA } from '@/store'
import { t } from '@/plugins/i18n'
import { computed, onMounted, ref, watch } from 'vue'
import { CustomerShopRespDTO } from '@/apis/interface/customer'
import { useStore } from 'vuex'
import { getCanTransformList, getUnCheckMoney, getWfTotalPriceApi } from '@/apis/fund'
import { formatPrice } from '@/views/fund/FundList/data'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { getQryDeliveryNum } from '@/apis/inShipping'
import { fa } from 'element-plus/lib/locale'
import { request } from '@/config/request/interceptors'

export default /*#__PURE__*/_defineComponent({
  props: {
    overviewInfo: { type: null, required: true },
    init: { type: Function, required: true }
  },
  setup(__props: any) {

const props = __props as {
    overviewInfo: CustomerShopRespDTO,
    init:(v?:boolean) => void
}
const coupon = ref({
  expire: 0
})
const store = useStore()
/** 是否为子账号 */
const isSub: boolean = store.getters.isSub
/** 当前店铺id */
const customerShopId = store.getters.curShop
const couponNum = computed(() => store.getters['coupon/getCanUseNum'])
watch(() => couponNum.value, (val) => {
  console.log('couponNum', val)
}, { immediate: true })
/** 当前店铺信息 */
const shopInfo = computed(() => {
  return store.getters.user.customerShopList.find((item: any) => item.customerShopId === customerShopId)
})
/** 购物车数量 */
const shopcartCount = computed(() => store.state.message.cart)
const noticeCount: any = computed(() => store.state.message.num)

/** 主账号余额 */
const availableAmount = computed(() => props.overviewInfo.availableAmount || 0)
/** 未入账金额-人民币 */
const unCheckCnyAmt = ref(0)
// const unCheckMoneyJPY = ref(0)

/** wf金额待入账金额 */
const wfPrice = ref(0)
// const wfPriceJPY = ref(0)
const deliveryNum = ref(0)
const transferList = ref([])
onMounted(async () => {
  const res3 = await request.market.coupon.customerExpireCount({ buType: 2 })
  // coupon.value.canUse = res1.data?.total ?? 0
  coupon.value.expire = res3.data || 0
  /** 获取未入账金额 */
  const res = await getUnCheckMoney({ currencyCode: 'CNY' })
  unCheckCnyAmt.value = res.data.unCheckCnyAmt
  //   unCheckMoneyJPY.value = res.data.unCheckAmt

  /** 获取wf金额待入账金额 */
  const res2 = await getWfTotalPriceApi({
    rechargeType: 1,
    balanceRechargeStatusList: [1, 2, 6],
    customerId: store.getters.user.customerId,
    payChannel: 5,
    // 默认人民币
    rechargeCurrencyCode: 'CNY'
  })
  wfPrice.value = res2.data?.rechargeCnyAmount || 0
  //   wfPriceJPY.value = res2.data?.rechargeAmount || 0

  isSub && getDeliveryNum()

  getCanTransformList().then((res: any) => {
    if (res.success) {
      transferList.value = res.data
    }
  })
})
/** 包裹因欠费而无法发货，请尽快充值  */
const getDeliveryNum = async () => {
  const res = await getQryDeliveryNum([{
    payStatus: 2,
    customerShopId
  }])
  if (res.data?.length) {
    deliveryNum.value = res.data?.[0].overdueCanotDeliverNum
  }
}

const transferVisible = ref(false)
// 唤起转账弹窗
const changeTransfer = () => {
  transferVisible.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AppLink, {
        to: _unref(useRtfix)(!_unref(isSub) ? 'CustomerFund' : 'StoreFund'),
        class: "wallet-balance-title",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
            _unref(taTrack)({
                event: _unref(TaEvent).BTN_CLICK,
                value: {
                    position: 'account_balance'
                }
            })
            ))
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(isSub) ? _unref(t)('主账号余额1') : _unref(t)('主账号余额')), 1),
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: _normalizeClass(Number(__props.overviewInfo?.availableAmount) < 0 ? 'font-red' : '')
        }, _toDisplayString(_unref(formatPrice)(_unref(availableAmount))), 3),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('元')), 1)
      ]),
      (_unref(isJA)() && !_unref(isSub))
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "wallet-balance-btn transform",
            style: {"margin-left":"8px"},
            onClick: changeTransfer
          }, _toDisplayString(_unref(t)('转账')), 1))
        : _createCommentVNode("", true),
      (!_unref(isSub))
        ? (_openBlock(), _createBlock(AppLink, {
            key: 1,
            to: _unref(useRtfix)('Recharge'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (
            _unref(taTrack)({
                event: _unref(TaEvent).BTN_CLICK,
                value: {
                    position: 'workbench_recharge'
                }
            })
            ))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('充值')), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      (!_unref(isSub))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("未入账金额")), 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(formatPrice)((unCheckCnyAmt.value + wfPrice.value)?.toFixed?.(2)) || 0), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(t)('元')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (Number(deliveryNum.value))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('有包裹因欠费而无法发货，请尽快转账')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14))
          ])),
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(AppLink, {
                    to: _unref(useRtfix)('userCoupons')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_popover, {
                        visible: !!coupon.value.expire,
                        disabled: !coupon.value.expire,
                        teleported: false,
                        "popper-class": "couponPopper",
                        width: 200,
                        placement: "top"
                      }, {
                        reference: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)("优惠券")), 1),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(couponNum)), 1)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" まもなく失効（" + _toDisplayString(coupon.value.expire) + "枚） ", 1)
                        ]),
                        _: 1
                      }, 8, ["visible", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _hoisted_22
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createVNode(AppLink, {
              to: _unref(useRtfix)('shopcart')
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(t)("购物车")), 1),
                _createElementVNode("span", {
                  class: "wallet-bottom-red",
                  style: _normalizeStyle(_unref(shopcartCount) > 0 ? 'color: #EA3B43;' : 'color: #505762;')
                }, _toDisplayString(_unref(shopcartCount)), 5)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(AppLink, {
              to: _unref(useRtfix)('Information')
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('消息')), 1),
                _createElementVNode("span", _hoisted_30, [
                  _createElementVNode("span", {
                    style: _normalizeStyle([_unref(noticeCount) ? 'color:#EA3B43;' : '', {"font-weight":"700"}])
                  }, _toDisplayString(_unref(noticeCount)), 5)
                ])
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ]),
    _createVNode(Transfer, {
      visible: transferVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((transferVisible).value = $event)),
      balance: _unref(availableAmount),
      "transfer-list": transferList.value,
      currencyCode: "CNY",
      onRefresh: _cache[3] || (_cache[3] = ($event: any) => (props.init(true)))
    }, null, 8, ["visible", "balance", "transfer-list"])
  ], 64))
}
}

})